export const CAPS_GRADES = [
    { value: 'R', label: 'Grade R' },
    ...Array.from({ length: 12 }, (_, index) => ({ value: String(index + 1), label: `Grade ${index + 1}` }))
];

export const CAPS_SUBJECTS = [
    'Mathematics',
    'English Home Language',
    'English First Additional Language',
    'Afrikaans Home Language',
    'Afrikaans First Additional Language',
    'Xitsonga Home Language',
    'isiZulu Home Language',
    'isiXhosa Home Language',
    'Sepedi Home Language',
    'Setswana Home Language',
    'Sesotho Home Language',
    'siSwati Home Language',
    'Tshivenda Home Language',
    'isiNdebele Home Language',
    'Life Skills',
    'Creative Arts',
    'Natural Sciences',
    'Social Sciences',
    'Technology',
    'Economic and Management Sciences',
    'Life Orientation',
    'Physical Sciences',
    'Life Sciences',
    'Geography',
    'History',
    'Accounting',
    'Business Studies',
    'Economics',
    'Computer Applications Technology',
    'Information Technology',
    'Consumer Studies',
    'Tourism',
    'Agricultural Sciences',
    'Engineering Graphics and Design',
    'Dramatic Arts',
    'Visual Arts',
    'Music',
    'Religion Studies'
];
